export default __webpack_public_path__ + "static/media/ac_sk.bb14f577.bmp";